import { useShipmentNotifications } from "~/features/shipment-management/hooks/use-shipment-notifications.ts";
import type { InsuranceFormData } from "~/shared/components/insurance-form/insurance-form.tsx";
import { InsuranceForm } from "~/shared/components/insurance-form/insurance-form.tsx";
import { useAutoSpinner } from "~/shared/hooks/use-global-spinner.ts";

import { useAddShipmentInsurance } from "../../hooks/use-add-shipment-insurance.ts";

type AddShipmentInsuranceModalProps = {
	showModal: boolean;
	poNumber: number;
	quoteId: number;
	defaultShipmentValue?: number | null;
	onClose: () => void;
};

export const AddShipmentInsuranceModal = ({
	showModal,
	poNumber,
	quoteId,
	defaultShipmentValue,
	onClose,
}: AddShipmentInsuranceModalProps) => {
	const { addShipmentInsurance, isSavingInsurance } = useAddShipmentInsurance();
	const { showSuccess, showError } = useShipmentNotifications();

	useAutoSpinner(isSavingInsurance);

	if (!showModal) return null;

	const handleSubmit = async (data: InsuranceFormData) => {
		onClose();
		try {
			await addShipmentInsurance({
				poNumber,
				quoteId,
				insuranceValue: data.shipmentValue,
				insuranceApplyTypeId: data.applyTo,
				insuranceProductTypeId: data.product,
			});
			showSuccess("Insurance purchased successfully.");
		} catch {
			showError("Failed to purchase insurance. Please try again.");
		}
	};

	return (
		<InsuranceForm
			hideApplyTo={true}
			initialValues={{ shipmentValue: defaultShipmentValue }}
			onClose={onClose}
			onSubmit={(data) => {
				void handleSubmit(data);
			}}
			title={"Purchase Insurance"}
		/>
	);
};
